// old menu handlers
export default function mobileMenuButtons() {
    const mobileMenuBtn = document.querySelector('.navbar_mobile[aria-controls="main-navigation"]');
    const mobileMenuCloseBtn = document.querySelector('.close-menu[aria-controls="main-navigation"]');
    const navOpenClass = 'nav_open';

    if (mobileMenuBtn) {
        mobileMenuBtn.addEventListener('click', function () {

            if (document.documentElement.classList.contains(navOpenClass)) {
                document.documentElement.classList.remove(navOpenClass);
                this.setAttribute('aria-expanded', 'false');
                this.setAttribute('aria-label', this.dataset.collapsed);
            } else {
                document.documentElement.classList.add(navOpenClass);
                this.setAttribute('aria-expanded', 'true');
                this.setAttribute('aria-label', this.dataset.expanded);
            }
        });
    }

    if (mobileMenuCloseBtn) {
        mobileMenuCloseBtn.addEventListener('click', function () {

            if (document.documentElement.classList.contains(navOpenClass)) {
                document.documentElement.classList.remove(navOpenClass);

                if (mobileMenuBtn) {
                    mobileMenuBtn.setAttribute('aria-expanded', 'false');
                    mobileMenuBtn.setAttribute('aria-label', mobileMenuBtn.dataset.collapsed);
                }
            }
        });
    }
}
